export const LeaseContractRouting = [
  {
    path: "/lease-config/lease-contract/list",
    name: "lease-contract-list",
    meta: { title: "租赁合同" },
    component: () =>
      import(
        /* webpackCh`un`kName: "project-config-type" */ "@/views/lease-config/lease-contract/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/lease-config/lease-contract/create",
    name: "lease-contract-create",
    meta: { title: "新增租赁合同",comName:'leaseConfigLeaseContractFormCreate' },
    component: () =>
      import(/* webpackChunkName: "contract-profile" */ "@/views/lease-config/lease-contract/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/lease-config/lease-contract/edit/:id",
    name: "lease-contract-edit",
    meta: { title: "编辑租赁合同",comName:'leaseConfigLeaseContractFormCreate' },
    component: () =>
      import(/* webpackChunkName: "contract-profile" */ "@/views/lease-config/lease-contract/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/lease-config/lease-contract/detail/:id",
    name: "lease-contract-detail",
    meta: { title: "租赁合同详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-profile" */ "@/views/lease-config/lease-contract/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/lease-config/lease-contract/flowPrint/:id",
    name: "lease-contract-flowPrint",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-profile" */ "@/views/lease-config/lease-contract/flow-print/index.vue"
      ),
  },
];
